import React from 'react'
import * as classes from './Container.module.scss'

function Container({ children }) {
    return <div className={classes.Container}>{children}</div>
}

export default Container
